import React from 'react';
import ContentSelfProvisionWA from '../components/pages/self-provision-WA/newUser/content';
import { connect } from 'react-redux';

const WASelfProvisionNewUser = (props) => {
  return (
    <div className="new-user-register-wa">
      <ContentSelfProvisionWA selfProvisionCreateForm={props.selfProvisionCreateForm} dispatch={props.dispatch} />
    </div>
  );
};
function mapStateToProps(state) {
  return {
    selfProvisionCreateForm: state.waitingAreaReducer.selfProvisionCreateForm,
  };
}

export default connect(mapStateToProps, null)(WASelfProvisionNewUser);
